import { useEffect } from "react";

// Silent recovery for the leaked body scroll-lock (CLAUDE.md: cover EVERY
// path, prefer silent recovery). Bottom sheets pin the page behind them with
// position:fixed; a navigation or an iOS back-swipe can strand that pin, and
// a stranded pin = a page that cannot scroll at all (founder:
// "total disaster" on the confirmation pages).
//
// Two heal moments, because they cover different arrival paths:
//   mount    — normal loads and SPA navigations. Also pins the page to the
//              top: every page using this hook is an entry surface where a
//              leftover scroll offset only ever looks broken.
//   pageshow(persisted) — iOS/Safari restoring the page from the back-forward
//              cache. That path SKIPS mount entirely (React never re-runs),
//              which is why the old RequestPage-only heal kept missing it.
//              No scroll pin here — the restored scroll spot is the user's.
export function useScrollLockHeal(active: boolean = true) {
  useEffect(() => {
    if (!active) return;
    const heal = () => {
      const s = document.body.style;
      if (s.position === "fixed") {
        s.position = "";
        s.top = "";
        s.width = "";
        s.overflow = "";
      }
    };
    heal();
    window.scrollTo(0, 0);
    const onPageShow = (e: PageTransitionEvent) => {
      if (e.persisted) heal();
    };
    window.addEventListener("pageshow", onPageShow);
    return () => window.removeEventListener("pageshow", onPageShow);
  }, [active]);
}
